import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SessionTimeoutWarning = ({ isVisible, onExtendSession, onLogout, timeRemaining }) => {
  const [countdown, setCountdown] = useState(timeRemaining || 300); // 5 minutes default

  useEffect(() => {
    if (!isVisible) return;

    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          onLogout();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [isVisible, onLogout]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds?.toString()?.padStart(2, '0')}`;
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-card border border-border rounded-lg p-6 max-w-md w-full mx-4 shadow-modal">
        <div className="flex items-center space-x-3 mb-4">
          <div className="w-10 h-10 bg-warning/10 rounded-full flex items-center justify-center">
            <Icon name="Clock" size={20} className="text-warning" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-foreground">Sitzung läuft ab</h3>
            <p className="text-sm text-muted-foreground">
              Ihre Sitzung läuft in {formatTime(countdown)} ab
            </p>
          </div>
        </div>

        <div className="mb-6">
          <p className="text-sm text-muted-foreground">
            Aus Sicherheitsgründen werden Sie automatisch abgemeldet, wenn Sie nicht aktiv sind. 
            Möchten Sie Ihre Sitzung verlängern?
          </p>
        </div>

        <div className="flex space-x-3">
          <Button
            variant="default"
            onClick={onExtendSession}
            className="flex-1"
            iconName="RefreshCw"
            iconPosition="left"
            iconSize={16}
          >
            Sitzung verlängern
          </Button>
          <Button
            variant="outline"
            onClick={onLogout}
            className="flex-1"
            iconName="LogOut"
            iconPosition="left"
            iconSize={16}
          >
            Abmelden
          </Button>
        </div>

        <div className="mt-4 pt-4 border-t border-border">
          <div className="flex items-center justify-center space-x-2 text-xs text-muted-foreground">
            <Icon name="Shield" size={12} />
            <span>Automatische Sicherheitsmaßnahme</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SessionTimeoutWarning;